const ease = [0.165, 0.84, 0.44, 1]

const animations = {
  heading: {
    hidden: {
      x: -30,
      opacity: 0,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        ease,
        delay: 0.5,
        duration: 1,
      },
    },
  },
}

export default animations
